/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Proof of delivery for a notification sent to a consumer.
 * @export
 * @interface ConsumerProofOfDelivery
 */
export interface ConsumerProofOfDelivery {
    /**
     * Unique identifier of the proof of delivery.
     * @type {string}
     * @memberof ConsumerProofOfDelivery
     */
    id: string;
    /**
     * HTTP status code received from the consumer.
     * @type {number}
     * @memberof ConsumerProofOfDelivery
     */
    httpStatusCode: number;
    /**
     * Response body received from the consumer.
     * @type {string}
     * @memberof ConsumerProofOfDelivery
     */
    responseBody?: string;
    /**
     * Timestamp when the notification request was sent.
     * @type {Date}
     * @memberof ConsumerProofOfDelivery
     */
    requestSentAt?: Date;
    /**
     * Timestamp when the response was received from the consumer.
     * @type {Date}
     * @memberof ConsumerProofOfDelivery
     */
    responseReceivedAt: Date;
    /**
     * Number of retry attempts made to deliver the notification.
     * @type {number}
     * @memberof ConsumerProofOfDelivery
     */
    retryAttempts: number;
    /**
     * The traceparent header as defined by W3C.
     * @type {string}
     * @memberof ConsumerProofOfDelivery
     */
    traceparentHeader?: string;
    /**
     * Payload of the notification sent to the consumer.
     * @type {string}
     * @memberof ConsumerProofOfDelivery
     */
    notificationPayload?: string;
}

/**
 * Check if a given object implements the ConsumerProofOfDelivery interface.
 */
export function instanceOfConsumerProofOfDelivery(value: object): value is ConsumerProofOfDelivery {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('httpStatusCode' in value) || value['httpStatusCode'] === undefined) return false;
    if (!('responseReceivedAt' in value) || value['responseReceivedAt'] === undefined) return false;
    if (!('retryAttempts' in value) || value['retryAttempts'] === undefined) return false;
    return true;
}

export function ConsumerProofOfDeliveryFromJSON(json: any): ConsumerProofOfDelivery {
    return ConsumerProofOfDeliveryFromJSONTyped(json, false);
}

export function ConsumerProofOfDeliveryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsumerProofOfDelivery {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'httpStatusCode': json['httpStatusCode'],
        'responseBody': json['responseBody'] == null ? undefined : json['responseBody'],
        'requestSentAt': json['requestSentAt'] == null ? undefined : (new Date(json['requestSentAt'])),
        'responseReceivedAt': (new Date(json['responseReceivedAt'])),
        'retryAttempts': json['retryAttempts'],
        'traceparentHeader': json['traceparentHeader'] == null ? undefined : json['traceparentHeader'],
        'notificationPayload': json['notificationPayload'] == null ? undefined : json['notificationPayload'],
    };
}

export function ConsumerProofOfDeliveryToJSON(json: any): ConsumerProofOfDelivery {
    return ConsumerProofOfDeliveryToJSONTyped(json, false);
}

export function ConsumerProofOfDeliveryToJSONTyped(value?: ConsumerProofOfDelivery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'httpStatusCode': value['httpStatusCode'],
        'responseBody': value['responseBody'],
        'requestSentAt': value['requestSentAt'] == null ? value['requestSentAt'] : value['requestSentAt'].toISOString(),
        'responseReceivedAt': value['responseReceivedAt'].toISOString(),
        'retryAttempts': value['retryAttempts'],
        'traceparentHeader': value['traceparentHeader'],
        'notificationPayload': value['notificationPayload'],
    };
}

